import React, { useEffect, useState } from "react";
import {
  Divider,
  Grid,
  TextField,
  InputAdornment,
  IconButton,
  Button,
} from "@mui/material";
import { formatCelular, formatCPF } from "../../../helpers";
import { Formik } from "formik";
import { ano, dia, mes } from "./dates";
import InputMask from "react-input-mask";
import { InputSelect } from "../../../components";
import styled from "@emotion/styled";
import logo from '../../../assets/logohorizontal.png'
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";


function DadosPessoais({
  data,
  onSubmit,
  usuarioSchema,
  ShowPassword,
  setDataN,
  dataN,
  largura,
  cpfValidacao,
  pessoaPolitica,
  showPass,
  SetCep,
  ValidarCpf ,
  messageError,
  setMessageError
}) {
  const ButtonCadastro = styled.button`
    border: 1px solid #947cfe;
    padding: 12px 8px;
    font-weight: bold;
    font-size: 14px;
    cursor: pointer;
    color: #947cfe;
    background-color: transparent;
    border-radius: 7px;
    margin-top: 15px;
    width: 100%;
    &:hover {
      color: #ffffff;
      background-color: #947cfe;
      transition: 0.3s ease-in-out
    }
  `;

  return (
    <Grid item sm={7} xs={12} >
      <Formik
        initialValues={data}
        onSubmit={onSubmit}
        validationSchema={usuarioSchema}
        enableReinitialize={true}
      >
        {({
          handleChange,
          handleBlur,
          setFieldValue,
          handleSubmit,
          values,
          errors,
          touched,
          validateField,
        }) => {
          return (
            <div style={{ padding: 20}}>
              <Grid container spacing={1}>

                

                <Grid item xs={12} sm={12}>
                  <img src={logo} />      



                  <h4
                    style={{
                      margin: "30px 0px 10px 0px",
                      color: "gray",
                      fontSize: "14px",
                    }}
                  >
                    DADOS PESSOAIS:
                  </h4>
                  <Divider />
                  <Grid
                    container
                    spacing={1}                  
                    style={{ fontSize: "12px", lineHeight: "2em" }}
                  >
                    <Grid item sm={5} xs={12}style={{}} >
                      Nome Completo
                      <TextField
                        name="nome"
                        fullWidth
                        size="small"
                        value={values.nome}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        error={Boolean(touched.nome && errors.nome)}
                        helperText={
                          Boolean(touched.nome && errors.nome) && errors.nome
                        }
                      />
                    </Grid>
                    <Grid item sm={3} xs={12}>
                      CPF:
                      <InputMask
                        mask="99999999999"
                        value={formatCPF(values.cpf)}
                        onChange={handleChange}
                        onBlur={(values) => ValidarCpf(values)}
                      >
                        {() => (
                          <TextField
                            placeholder="00000000000"
                            fullWidth
                            size="small"
                            name="cpf"
                            error={Boolean(touched.cpf && errors.cpf)}
                            helperText={
                              Boolean(touched.cpf && errors.cpf) && errors.cpf
                            }
                          />
                        )}
                      </InputMask>
                      {largura < 1000 ? (
                        ""
                      ) : (
                        <div style={{ fontSize: 10, color: "#ff0010" }}>
                          {cpfValidacao && cpfValidacao ? "" : "CPF INVÁLIDO"}{" "}
                        </div>
                      )}
                    </Grid>
                    <Grid item sm={4} xs={6}>
                      Sexo:
                      <InputSelect
                        name="sexo"
                        values={[
                          { value: "", label: "Selecione" },
                          { value: "M", label: "Masculino" },
                          { value: "F", label: "Feminino" },
                        ]}
                        value={values.sexo}
                        onChange={handleChange}
                        error={Boolean(touched.sexo && errors.sexo)}
                        helperText={
                          Boolean(touched.sexo && errors.sexo) && errors.sexo
                        }
                      />
                    </Grid>

                    <Grid item sm={3} xs={6}>
                      Estado Civil:
                      <InputSelect
                        name="estadoCivil"
                        values={[
                          { value: "", label: "Selecione" },
                          { value: "S", label: "Solteiro" },
                          { value: "C", label: "Casado" },
                          { value: "D", label: "Divorciado" },
                          { value: "V", label: "Viúvo" },
                        ]}
                        value={values.estadoCivil}
                        onChange={handleChange}
                        error={Boolean(touched.estadoCivil && errors.estadoCivil)}
                        helperText={
                          Boolean(touched.estadoCivil && errors.estadoCivil) && errors.estadoCivil
                        }
                      />
                    </Grid>
                    <Grid item sm={3} xs={12}>
                      Celular:
                      <TextField
                        placeholder="(00) 0 0000-0000"
                        name="celular"
                        value={formatCelular(values.celular)}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        onBlur={handleBlur}
                        error={Boolean(touched.celular && errors.celular)}
                        helperText={
                          Boolean(touched.celular && errors.celular) &&
                          errors.celular
                        }
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      Data de nascimento:
                      <Grid container spacing={1}>
                        <Grid item sm={4} xs={4}>
                          <InputSelect
                            name="diaValidation"
                            values={[ {value: "", label: "Dia"}].concat(dia)}
                            value={dataN.diaNascimento}
                            onChange={(e) => setDataN({...dataN, diaNascimento: e.target.value, }) }  
                          />
                        </Grid>
                        <Grid item sm={4} xs={4}>
                          <InputSelect
                            name="mesNascimento"
                            values={mes}
                            value={dataN.mesNascimento}
                            onChange={(e) =>
                              setDataN({
                                ...dataN,
                                mesNascimento: e.target.value,
                              })
                            }
                            error={Boolean(touched.mes && errors.mes)}
                            helperText={
                              Boolean(touched.mes && errors.mes) && errors.mes
                            }
                          />
                        </Grid>
                        <Grid item sm={4} xs={4}>
                          <InputSelect
                            name="ano"
                            values={ano}
                            value={dataN.anoNascimento}
                            onChange={(e) =>
                              setDataN({
                                ...dataN,
                                anoNascimento: e.target.value,
                              })
                            }
                            error={Boolean(touched.ano && errors.ano)}
                            helperText={
                              Boolean(touched.ano && errors.ano) && errors.ano
                            }
                          />
                        </Grid>
                      </Grid>
                    </Grid>
                    {/* <Grid item sm={3} xs={12}>
                      {" "}
                      Pessoa politicamente exposta¹
                      <InputSelect
                        name="pessoaPolitica"
                        values={[
                          { value: "", label: "Não" },
                          { value: "true", label: "Sim" },
                        ]}
                        value={pessoaPolitica}
                        onChange={(e) =>
                          setPessoaPoliticamenteExposta(e.target.value)
                        }
                      />
                    </Grid> */}

                    <Grid item sm={6} xs={12}>
                      Email:
                      <TextField
                        value={values.email}
                        type="email"
                        fullWidth
                        size="small"
                        onChange={handleChange}
                        name="email"
                        placeholder="email@email.com"
                        onBlur={handleBlur}
                        error={Boolean(touched.email && errors.email)}
                        helperText={
                          Boolean(touched.email && errors.email) && errors.email
                        }
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      Senha:
                      <TextField
                        value={values.password}
                        type={showPass ? "text" : "password"}
                        onChange={handleChange}
                        name="password"
                        fullWidth
                        size="small"
                        onBlur={handleBlur}
                        error={Boolean(touched.password && errors.password)}
                        helperText={
                          Boolean(touched.password && errors.password) &&
                          errors.password
                        }
                        InputProps={{
                          endAdornment: (
                            <InputAdornment
                              position="end"
                              style={{
                                cursor: "Pointer",
                                opacity: "0.7",
                              }}
                              onClick={ShowPassword}
                            >
                              <IconButton onClick={ShowPassword}>
                                {showPass ? (
                                  <p style={{ fontSize: "10px" }}>
                                    Ocultar Senha
                                  </p>
                                ) : (
                                  <p style={{ fontSize: "10px" }}>
                                    Mostar Senha
                                  </p>
                                )}
                              </IconButton>
                            </InputAdornment>
                          ),
                        }}
                      />
                    </Grid>
                  </Grid>

                  <h4
                    style={{
                      margin: "30px 0px 10px 0px",
                      color: "gray",
                      fontSize: "14px",
                    }}
                  >
                    ENDEREÇO:{" "}
                  </h4>
                  <Divider />
                  <Grid
                    container
                    spacing={1}
                  
                    style={{ fontSize: "12px", lineHeight: "2em" }}
                  >
                    <Grid item sm={2} xs={12}>
                      CEP
                      <TextField
                        placeholder="00.000-000"
                        name="cep"
                        fullWidth
                        size="small"
                        inputProps={{ maxLength: 8 }}
                        value={values.cep}
                        onChange={handleChange}
                        onBlur={(ev) =>
                          SetCep(ev, setFieldValue, validateField)
                        }
                        error={Boolean(touched.cep && errors.cep)}
                        helperText={
                          Boolean(touched.cep && errors.cep) && errors.cep
                        }
                      />
                    </Grid>

                    <Grid item sm={5} xs={12}>
                      Cidade
                      <TextField
                        value={values.cidade}
                        onChange={handleChange}
                        name="cidade"
                        fullWidth
                        size="small"
                        onBlur={handleBlur}
                        error={Boolean(touched.cidade && errors.cidade)}
                        helperText={
                          Boolean(touched.cidade && errors.cidade) &&
                          errors.cidade
                        }
                      />
                    </Grid>

                    <Grid item sm={5} xs={12}>
                      Rua
                      <TextField
                        value={values.endereco}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        name="endereco"
                        onBlur={handleBlur}
                        error={Boolean(touched.endereco && errors.endereco)}
                        helperText={
                          Boolean(touched.endereco && errors.endereco) &&
                          errors.endereco
                        }
                      />
                    </Grid>
                    <Grid item sm={6} xs={12}>
                      Bairro
                      <TextField
                        value={values.bairro}
                        onChange={handleChange}
                        name="bairro"
                        fullWidth
                        size="small"
                        onBlur={handleBlur}
                        error={Boolean(touched.bairro && errors.bairro)}
                        helperText={
                          Boolean(touched.bairro && errors.bairro) &&
                          errors.bairro
                        }
                      />
                    </Grid>

                    <Grid item sm={2} xs={4}>
                      Número
                      <TextField
                        value={values.numero}
                        onChange={handleChange}
                        name="numero"
                        size="small"
                        fullWidth
                        onBlur={handleBlur}
                        error={Boolean(touched.numero && errors.numero)}
                        helperText={
                          Boolean(touched.numero && errors.numero) &&
                          errors.numero
                        }
                      />
                    </Grid>
                    <Grid item sm={2} xs={4}>
                      UF
                      <TextField
                        value={values.uf}
                        onChange={handleChange}
                        name="uf"
                        fullWidth
                        size="small"
                        onBlur={handleBlur}
                        error={Boolean(touched.uf && errors.uf)}
                        helperText={
                          Boolean(touched.uf && errors.uf) && errors.uf
                        }
                      />
                    </Grid>
                    <Grid item sm={2} xs={4}>
                      Complemento
                      <TextField
                        value={values.complemento}
                        onChange={handleChange}
                        fullWidth
                        size="small"
                        name="complemento"
                      />
                    </Grid>
                  </Grid>

                  <div style={{ marginTop: "1.5em" }}>
              
                {messageError && (
                  <>
                    <Alert severity="error">
                      <AlertTitle> {messageError?.message} </AlertTitle>

                      <Divider />
                      {messageError &&
                        messageError?.validationError?.map((item) => {
                          return (
                            <div>
                              <li style={{ color: "#a52424" }}>
                                {item.message}
                              </li>
                            </div>
                          );
                        })}
                    </Alert>
                  </>
                )}
              </div>
                  <ButtonCadastro onClick={handleSubmit} type="submit">
                    CADASTRAR
                  </ButtonCadastro>
                </Grid>
              </Grid>
            </div>
          );
        }}
      </Formik>
    </Grid>
  );
}

export default DadosPessoais;
